export default {
  title: {
    text: "正极材料价格趋势",
    //subtext: 'Feature Sample: Gradient Color, Shadow, Click Zoom'
  },
  legend: {
    top: 100,
    data: ["三元材料", "磷酸铁锂", "钴酸锂", "锰酸锂"],
  },
  grid: {
    top: 240,
  },
  tooltip: {
    trigger: "axis",
  },
  xAxis: {
    name: "时间",
    type: "category",
    axisLabel: {
      show: true,
      textStyle: {
        color: "white",
        fontSize: 30,
      },
    },
    data: ["2017", "Q2", "Q3", "Q4", "Q1", "Q2", "Q3", "Q4", "2019"],
  },
  yAxis: {
    name: "价格 万元/吨",
    type: "value",
    interval: 20,
  },
  series: [
    {
      name: "三元材料",
      type: "line",
      itemStyle: {
        normal: {
          borderWidth: 2,
        },
      },
      lineStyle: {
        normal: {
          width: 8,
        },
      },
      symbolSize: 20,
      smooth: true,
      data: [
        19.0994,
        19.0217,
        20.1863,
        21.5062,
        23.059,
        21.5062,
        18.0124,
        16.5373,
        15.5056,
      ],
    },
    {
      name: "磷酸铁锂",
      type: "line",
      smooth: true,
      itemStyle: {
        normal: {
          borderWidth: 2,
        },
      },
      lineStyle: {
        normal: {
          width: 8,
        },
      },
      symbolSize: 20,
      data: [
        8.8509,
        8.3851,
        9.3168,
        9.0839,
        8.2298,
        7.3758,
        6.3665,
        5.8229,
        5.5358,
      ],
    },
    {
      name: "钴酸锂",
      type: "line",
      itemStyle: {
        normal: {
          borderWidth: 2,
        },
      },
      lineStyle: {
        normal: {
          width: 8,
        },
      },
      symbolSize: 20,
      smooth: true,
      data: [
        41.4645,
        39.405,
        39.8169,
        40.778,
        45.7208,
        50.5263,
        42.151,
        33.3638,
        24.5767,
      ],
    },
    {
      name: "锰酸锂",
      type: "line",
      itemStyle: {
        normal: {
          borderWidth: 2,
        },
      },
      lineStyle: {
        normal: {
          width: 8,
        },
      },
      symbolSize: 20,
      smooth: true,
      data: [
        5.6293,
        5.4919,
        6.0412,
        6.4531,
        6.5904,
        6.4135,
        6.1785,
        4.8055,
        4.119,
      ],
    },
  ],
};
